import axios from 'axios';
import getCurrentLanguage from '../../utils/functions/get-language';

// Create the Axios instance
const api = axios.create({
  baseURL: process.env.SERVICE, // Ensure SERVICE is defined in your environment variables
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Add an interceptor to set the `interface-language` header globally
api.interceptors.request.use(
  (config) => {
    // Retrieve the language dynamically
    const language = getCurrentLanguage();

    // Ensure the headers object exists
    // eslint-disable-next-line no-param-reassign
    config.headers = config.headers || {};

    // Set the custom `interface-language` header
    // eslint-disable-next-line no-param-reassign
    config.headers['interface-language'] = String(language);

    // Return the modified config
    return config;
  },
  (error) => Promise.reject(error),
);

export default api;
